<template>
  <div class="layout">
    <el-row class="tac" type="flex">
      <el-col :span="24">
        <div class="layout-header">
          <div class="layout-header-logo">
            <img class="headImage" :src="imgUrl" style="height:42px;margin-top:5px" />
          </div>
          <div style=" float: right">
            <span class="layout-header-font">{{ shopName }}</span>
            <el-popover placement="bottom" width="150" trigger="hover">
              <el-row>
                <el-col :span="24" style="text-align:center">
                  <el-button type="text" class="layout-header-font" @click="centerDialogVisible = true">修改密码</el-button>
                </el-col>
                <el-col :span="24" style="text-align:center">
                  <el-button type="text" @click="submitLogout" class="layout-header-font">注销</el-button>
                </el-col>
              </el-row>
              <span slot="reference" class="layout-header-font" style="color:white">{{ managername }}</span>
            </el-popover>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="tac" type="flex">
      <el-col :span="3" class="layout-menu-left">
        <el-menu default-active="formalUserManage" style="width:100%" ref="mainMenu" :active-name="activeName"
          @select="selectMenu" class="el-menu-demo" background-color="#464c5b" text-color="lightgray"
          :unique-opened="true">
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span slot="title">企业管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="formalUserManage" style="min-width:100px">人员管理</el-menu-item>
              <el-menu-item index="formalProjectSitesManage" style="min-width:100px">项目点管理</el-menu-item>
              <el-menu-item index="departmentManage" style="min-width:100px">部门管理</el-menu-item>
              <!-- <el-menu-item index="costReport" style="min-width:100px">费用管理</el-menu-item> -->
              <el-menu-item index="costCategory" style="min-width:100px">费用类别</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span slot="title">参数配置</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="incomeType" style="min-width:100px">收入类别管理</el-menu-item>
              <el-menu-item index="FoodType" style="min-width:100px">餐别管理</el-menu-item>
              <el-menu-item index="DKType" style="min-width:100px">档口类型管理</el-menu-item>
              <el-menu-item index="rechargeManage" style="min-width:100px">充值方式管理</el-menu-item>
              <el-menu-item index="accountClose" style="min-width:100px">关账管理</el-menu-item>
              <el-menu-item index="settlementModeManagement" style="min-width:100px">结算模式管理</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- <el-submenu index="3">
                        <template slot="title">
                            <i class="el-icon-menu"></i>
                            <span slot="title">数据管理</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item index="orderManager" style="min-width:100px">订单管理</el-menu-item>
                            <el-menu-item index="printOrder" style="min-width:100px">打印订单</el-menu-item>
                            <el-menu-item index="putoutStorage" style="min-width:100px">仓库管理</el-menu-item>
                            <el-menu-item index="storageDocument" style="min-width:100px">出库单管理</el-menu-item>
                            <el-menu-item index="invenDocument" style="min-width:100px">盘库单管理</el-menu-item>
                            <el-menu-item index="checkPrice" style="min-width:100px">价格校对</el-menu-item>
                            <el-menu-item index="updateOrder" style="min-width:100px">更新订单金额</el-menu-item>
                        </el-menu-item-group>
                    </el-submenu> -->
        </el-menu>
      </el-col>
      <el-col :span="21" :offset="3" class="layout-main-content">
        <div class="layout-content">
          <div class="layout-content-main">
            <router-view></router-view>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 修改密码模态框 -->
    <el-dialog title="修改密码" :visible.sync="centerDialogVisible" center width="600px" :close-on-click-modal="false">
      <el-form :model="passForm" ref="passForm" label-position="left" :rules="rules" style="padding-top:0;margin-top:0">
        <el-form-item label="旧 密 码：" prop="oldpass" :label-width="formLabelWidth">
          <label slot="label">旧&nbsp;&nbsp;密&nbsp;&nbsp;码：</label>
          <el-input v-model="passForm.oldpass" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="新 密 码：" prop="newpass" :label-width="formLabelWidth">
          <label slot="label">新&nbsp;&nbsp;密&nbsp;&nbsp;码：</label>
          <el-input v-model="passForm.newpass" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="repass" :label-width="formLabelWidth">
          <el-input v-model="passForm.repass" auto-complete="off" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button @click="submitPassForm('passForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { logout, editPass } from '@/api/Login';

export default {
  // 菜单push路由
  mounted() {
    this.changeMenu(this.$route.name);
    this.isRightUrl();
  },
  watch: {
    $route(to) {
      this.changeMenu(to.name);
      this.$router.push({ name: to.name });
    },
  },
  data() {
    // 修改密码验证
    const validatePass0 = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入原始密码'));
      }
      callback();
    };
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (this.passForm.newpass !== 'code') {
          this.$refs.passForm.validateField('repass');
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认新密码'));
      } else if (value !== this.passForm.newpass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    const validateCheck = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('验证码不能为空'));
      }
      callback();
    };
    return {
      shopName: '',
      managername: sessionStorage.getItem('name'),
      activeName: 'companyAdmin',
      centerDialogVisible: false,
      passForm: {
        oldpass: '',
        newpass: '',
        repass: '',
        check: '',

      },
      rules: {
        oldpass: [
          { validator: validatePass0, trigger: 'blur' },
        ],
        newpass: [
          { validator: validatePass, trigger: 'blur' },
          {
            min: 1, max: 8, message: '长度在 1 到 8 个字符', trigger: 'blur',
          },
        ],
        repass: [
          { validator: validatePass2, trigger: 'blur' },
          {
            min: 1, max: 8, message: '长度在 1 到 8 个字符', trigger: 'blur',
          },
        ],
        check: [
          { validator: validateCheck, trigger: 'blur' },
        ],
      },
      formLabelWidth: '100px',
      imgUrl: '',
    };
  },
  methods: {
    selectMenu(name) {
      this.$router.push({ name });// push()方法设置路由
      console.log(name);
    },
    changeMenu(name) {
      this.activeName = name;
    },
    // 注销
    submitLogout() {
      this.$confirm('您确认退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const data = {};
        logout(data).then((res) => {
          sessionStorage.removeItem('session');
          sessionStorage.removeItem('userId');
          this.$router.push({ name: 'Login' });
        }).catch((error) => {
          this.$message.show({
            type: 'info',
            text: error,
          });
        });
      });
    },
    // 修改密码
    submitPassForm(formName) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const data = { // http请求的参数
                NEW_PASSWORD: this.passForm.newpass,
                OLD_PASSWORD: this.passForm.oldpass,
              };
              editPass(data).then((res) => {
                this.$message.show({
                  text: '修改成功，重新返回登录',
                  type: 'success',
                });
                this.$router.push({ path: '/' });
                document.body.style.cursor = 'default';
              }).catch((error) => {
                this.$message.show({
                  text: error,
                  type: 'error',
                });
                document.body.style.cursor = 'default';
              });
            } else {
              console.log('error submit!!');
              document.body.style.cursor = 'default';
              return false;
            }
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    // 通过不同网址显示不同团餐公司的信息
    isRightUrl() {
      const baseRightUrl = window.location.href;
      const rightData = baseRightUrl.split('/');
      // console.log(rightData[3])
      if (rightData[3] === 'tc_admin') {
        // this.imgUrl = 'https://service.linkda.com.cn/file/tcpics/mjd/background.png';
        this.imgUrl = 'https://service.linkda.com.cn/file/tcpics/lkd/background.png';
        // this.imgUrl = 'https://service1.mckintey.top/file/tcpics/mjd/background.png'
        // this.imgUrl = 'https://service.linkda.com.cn/file/tcpics/Newcapec/background.png'
        // this.imgUrl = 'https://service.linkda.com.cn/file/tcpics/yunpeng/background.png'
        // this.imgUrl = 'https://service.linkda.com.cn/file/tcpics/Newcapec/background.png';
      } else if (rightData[3] === '#') {
        // this.imgUrl = 'https://service.linkda.com.cn/file/tcpics/mjd/background.png';
        this.imgUrl = 'https://service.linkda.com.cn/file/tcpics/lkd/background.png';
        // this.imgUrl = 'https://service1.mckintey.top/file/tcpics/mjd/background.png'
        // this.imgUrl = 'https://service.linkda.com.cn/file/tcpics/Newcapec/background.png'
        // this.imgUrl = 'https://service.linkda.com.cn/file/tcpics/yunpeng/background.png'
        // this.imgUrl = 'https://service.linkda.com.cn/file/tcpics/Newcapec/background.png';
      } else {
        this.imgUrl = `https://service.linkda.com.cn/file/tcpics/${rightData[3]}/background.png`;
        // this.imgUrl = 'https://service1.mckintey.top/file/tcpics/'+ rightData[3]+ '/background.png'
      }
    },
  },
};
</script>
<style>
.layout {
  background: #f5f7f9;
  position: relative;
  height: 100%;
  width: 100%;
}

.layout-menu-left {
  position: fixed;
  background: #464c5b;
  left: 0;
  height: 100%;
  min-width: 130px;
  margin-top: 61px;
}

.layout-main-content {
  position: absolute;
  margin-top: 61px;
}

.layout-header {
  z-index: 10;
  position: fixed;
  width: 100%;
  background: linear-gradient(#373737, #464C5B);
  line-height: 60px;
  text-align: right;
  border-bottom: 1px solid #505664;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.layout-header-font {
  font-size: 16px;
  cursor: pointer;
  margin-right: 20px;
}

.layout-header-icon {
  font-size: 25px;
  color: #2d8cf0;
  position: relative;
  left: 0;
  top: 4px;
  margin-right: 5px;
}

.layout-content-main {
  padding: 10px;
}

.layout-content {
  margin: 15px;
  overflow: hidden;
  background: #fff;
  border-radius: 4px;
}

.layout-header-logo {
  height: 60px;
  width: 210px;
  float: left;
}

.layout-header-logo img {
  margin-right: 27%;
  height: 40px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Public.vue